<!-- Tabs (Users/Hierarchy) -->
<div class="ltms-tabs">
   <span class="ltms-tab" (click)="onClickingNavigation('users')" [ngClass]="{ 'ltms-active-tab': activeTab === 'users' }">Users</span>
   <!-- <span class="ltms-tab" (click)="onClickingNavigation('hierarchy')" [ngClass]="{ 'ltms-active-tab': activeTab === 'hierarchy' }">Hierarchy</span> -->
</div>

<!-- Discription -->
<span class="ltms-description">Create, manage, and control dashboard user access and permissions across the organisation hierarchy.</span>

<!-- Tab Content -->
<div *ngIf="activeTab === 'users'">
   <div class="filter-box">
      <div class="left-group">
         <!-- New User Access Button -->
         <button class="button primary-btn" [disabled]="!isUserHasWriteAccess" (click)="openRightPanelFN('New User Access', '')">New User Access</button>
         <!-- Manual Source Checkbox Button -->
         <button class="button checkbox-btn" [ngClass]="{'non-click': !isUserListLoad}" (click)="checkBoxButtonToggle('dashboard')"><img [src]="selectedSource === 'dashboard' ? 'assets/images/checkBox-circle-fill-svg.svg' : 'assets/images/checkbox-blank-circle-outline.svg'"><span>Added via Dashboard</span></button>
         <!-- Automatic Source Checkbox Button -->
         <button class="button checkbox-btn" [ngClass]="{'non-click': !isUserListLoad}" (click)="checkBoxButtonToggle('afp')"><img [src]="selectedSource === 'afp' ? 'assets/images/checkBox-circle-fill-svg.svg' : 'assets/images/checkbox-blank-circle-outline.svg'"><span>Added via Hierarchy</span></button>
         <!-- Add Filter Button -->
         <div class="addFilterContainer" [ngClass]="{'non-click': !isUserListLoad}">
            <button (click)="openRightPanelFN('Add Filter', '')" [class.hasDot]="showRedDot">
               <img class="addFilterImgOutline" src="assets/images/filter-outline.svg" alt="Filter outline" />
               <img class="addFilterImgFill" src="assets/images/filter-fill.svg" alt="Filter filled" />
               <span>More filters</span>
            </button>
         </div>
         <!-- 3 Vertical Dots Dropdown -->
         <!-- <div class="three-dot-dropdown-container" (click)="showThreeDropdownFN()" #threeDotContainer>
            <img class="three-dot-dropdown" src="assets/images/vertical-3-dots.svg">
            <div class="three-dot-dropdown-menu" *ngIf="showThreeDropdown">
               <ul>
                  <li (click)="createJob()"><img src="assets/images/download-2.svg"><span>User Access Report</span></li>
                  <li (click)="openRightPanelFN('Import Users', '')"><img src="assets/images/file-import-outline.svg"><span>Import Users</span></li>
                  <li (click)="openRightPanelFN('Upload Hierarchy', '')"><img src="assets/images/file-upload-outline.svg"><span>Upload Hierarchy</span></li>
               </ul>
            </div>
         </div> -->
      </div>
      <div class="right-group">
         <!-- <div class="addFilterContainer">
            <button (click)="createJob()">
               <img class="addFilterImgOutline" src="assets/images/download-2.svg" />
               <img class="addFilterImgFill" src="assets/images/download-2.svg" />
               <span>User Access Report</span>
            </button>
         </div> -->
         <!-- Save button is connected with bulk edit so hiding this as well. -->
         <!-- <button class="bulkSaveButton" [class.active]="isBulkSaveActive" [disabled]="!isBulkSaveActive" (click)="bulkUpdate()">Save</button>         -->
         <app-search-dropdown [ngClass]="{'non-click': !isUserListLoad}" #searchDropdownComp [options]="['Email Address']" (searchChange)="onSearchChanged($event)"></app-search-dropdown>
      </div>
   </div>
   <div class="loader" *ngIf="isLoading"><app-ltms-loader></app-ltms-loader></div>
   <div class="error" *ngIf="isError"><app-ltms-error [code]="'404'"></app-ltms-error></div>
   <div class="table-card-container" *ngIf="!isLoading && !isError">
      <div class="table-card-header">
         <div class="header-cell header-center">
            <!-- We are comminting this as disscussed on call with Product Team, we will develope new UI for the bul edit and for this new API is also required. -->
            <!-- <input type="checkbox" disabled class="checkbox" [(ngModel)]="selectAll" (change)="onSelectAllChange()" /> -->
         </div>
         <div class="header-cell header-center"></div>
         <div class="header-cell">Users</div>
         <div class="header-cell table-sorting cursorPointer" (click)="sortByEmail()">
            Email
            <img src="assets/images/arrow-up.svg"   [ngClass]="{ 'rotated': sortDirection === 'desc' }">
         </div>
         <div class="header-cell">Access</div>
         <div class="header-cell">User Type</div>
         <div class="header-cell">Added Via</div>
         <div class="header-cell-toggle header-center">
            <img
               [src]="headerToggles.hasDashboardAccess ? 'assets/images/toggle-switch-fill.svg' : 'assets/images/toggle-switch.svg'"
               class="header-toggle"
               alt="toggle dashboard"
               (click)="toggle('hasDashboardAccess')"
               *ngIf="showPermissionToggles"
            />
            <span class="header-label">Dashboard</span>
         </div>
         <div class="header-cell-toggle header-center">
            <img
               [src]="headerToggles.replyBackAllowed ? 'assets/images/toggle-switch-fill.svg' : 'assets/images/toggle-switch.svg'"
               class="header-toggle"
               alt="toggle reply"
               (click)="toggle('replyBackAllowed')"
               *ngIf="showPermissionToggles"
            />
            <span class="header-label">Reply</span>
         </div>
         <div class="header-cell-toggle header-center">
            <img
               [src]="headerToggles.reportDownloadAllowed ? 'assets/images/toggle-switch-fill.svg' : 'assets/images/toggle-switch.svg'"
               class="header-toggle"
               alt="toggle adr"
               (click)="toggle('reportDownloadAllowed')"
               *ngIf="showPermissionToggles"
            />
            <span class="header-label">ADR</span>
         </div>
         <div class="header-cell-toggle header-center">
            <img
               [src]="headerToggles.hasMobileAccess ? 'assets/images/toggle-switch-fill.svg' : 'assets/images/toggle-switch.svg'"
               class="header-toggle"
               alt="toggle mobile"
               (click)="toggle('hasMobileAccess')"
               *ngIf="showPermissionToggles"
            />
            <span class="header-label">Mobile</span>
         </div>
         <div class="header-cell header-center">Status</div>
      </div>
      <div class="table-card-row" *ngFor="let user of filteredUserList" [ngClass]="{rowHighlight: user.managerType == 3}">
         <div class="header-cell header-center">
            <!-- This checkbox utton is connected with bulk edit so hiding this as well. -->
            <!-- <input disabled *ngIf="user.managerType !== 3 && user.source === 'dashboard' && user.statusInfo?.status !== 'Unverified'" type="checkbox" class="checkbox" [(ngModel)]="user.selected" (change)="updateSelectAllState()" /> -->
         </div>
         <div class="header-cell header-center edit-user-icon">
            <img *ngIf="user.source === 'dashboard' && user.statusInfo?.status !== 'Unverified'" class="outline" src="assets/images/account-edit-outline.svg" />
            <img *ngIf="user.source === 'dashboard' && user.statusInfo?.status !== 'Unverified'" class="fill" src="assets/images/account-edit-fill.svg" (click)="openRightPanelFN('Edit user', user)" />
         </div>
         <div class="header-cell header-cell-name-wrapper">
            <span class="header-cell-text header-cell-name">{{ user.name }}</span>
            <span class="header-cell-text header-cell-phoneNumber">{{ user.phoneNumber }}</span>
         </div>
         <div class="header-cell email-cell">
            <div class="email-wrapper">
               <img *ngIf="!(user.statusInfo?.status == 'Unverified')" class="emailVerified" src="assets/images/checkBox-circle-fill-svg.svg" />
               <img *ngIf="user.statusInfo?.status == 'Unverified'" class="emailVerified emailNonVerified" src="assets/images/checkbox-non-fill.svg" />
               <span class="email-text">{{ user.emailIdWithCount }}</span>
            </div>
            <button *ngIf="user.statusInfo?.status == 'Unverified'" [disabled]="!isUserHasWriteAccess" (click)="sendVerificationMail(user)" class="email-btn">Verify Email</button>
         </div>
         <div class="header-cell header-cell-text header-cell-access">{{ user.access }}</div>
         <div class="header-cell header-cell-text">{{ getUserType(user.emailId) }}</div>
         <div class="header-cell header-cell-name-wrapper">
            <span class="header-cell-text header-cell-name user-source">{{ user.source === 'afp' ? 'Hierarchy' : user.source }}</span>
            <span class="header-cell-text header-cell-phoneNumber">{{ getDateTime(user.createdDate) }}</span>
         </div>
         <div class="header-cell header-center" *ngFor="let field of checkboxFields">
            <img
               [src]="getToggleImage(user, field.key)"
               [class.cursor-blocked]="isToggleBlocked(user, field.key) || !isUserHasWriteAccess"
               (click)="onToggleClick(user, field.key)"
               alt="toggle switch"
            />
         </div>
         <div class="header-cell header-center header-cell-text"><span [style.background]="user.statusInfo?.bgColor" class="status-btn">{{ user.statusInfo?.status }}</span></div>
      </div>
   </div>
   <div class="load-more-container" *ngIf="(isLoadMore || searchHasMoreData) && !isLoading && !isError">
      <button class="load-more-btn" (click)="loadMore()">Load more</button>
   </div>
</div>

<div *ngIf="activeTab === 'hierarchy'">
   <div class="filter-box">
      <div class="left-group">
         <!-- Add a Level Button -->
         <button class="button primary-btn">Add a Level</button>
         <!-- Upload Hierarchy Button -->
         <button class="button checkbox-btn hierarchy-btn"><img src="assets/images/file-upload-outline.svg"><span>Upload Hierarchy</span></button>
      </div>
      <div class="right-group">
         <app-score-search-bar [config]="levelSearch"></app-score-search-bar>
      </div>
   </div>
   <div class="user-table-container">
      <table class="custom-table">
         <thead>
            <tr>
               <th class="edit-icon"></th>
               <th class="organisationLevel">Organisation Level</th>
               <th class="level">Level</th>
               <th class="level-edit"></th>
            </tr>
         </thead>
         <tbody>
            <ng-container *ngFor="let level of levelList | keyvalue; let i = index">
               <tr *ngIf="level.value">
                  <td class="edit-icon"></td>
                  <td class="organisationLevel">
                     <span>{{ level.value }}</span>
                     <!-- <input type="text" placeholder="{{ level.value }}"> -->
                  </td>
                  <td class="level">{{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }}</td>
                  <td class="level-edit">
                     <img src="assets/images/edit-icon.svg">
                     <img class="fadedImg" src="assets/images/trash-can-outline.svg">
                  </td>
               </tr>
            </ng-container>
         </tbody>
      </table>
   </div>
</div>

<!-- Right Panel -->
<div class="side-panel" *ngIf="openRightPanel">
   <!-- Overlay -->
   <div class="overlay" (click)="closeRightPanelFN(rightPanelHeading)"></div>
   <!-- Right Panel Box -->
   <div class="panel-container">
      <div class="panel-header-container">
         <span>{{ rightPanelHeading }}</span>
         <img src="./assets/images/close.svg" (click)="closeRightPanelFN(rightPanelHeading)">
      </div>
      <!-- Tab inside Right Panel -->
      <div class="ltms-tabs rightPanelTab" *ngIf="rightPanelHeading === 'New User Access'">
         <span class="ltms-tab" [ngClass]="{ 'ltms-active-tab': currentSubTab === 'profile' }" (click)="changeSubTab('profile')">Profile</span>
         <span class="ltms-tab" [ngClass]="{ 'ltms-active-tab': currentSubTab === 'access' }" (click)="changeSubTab('access')">Access</span>
      </div>
      <!-- Panel Container -->
      <div class="panel-content-container">
         <!-- New User Access Form - Profile -->
         <ng-container *ngIf="rightPanelHeading === 'New User Access' && currentSubTab === 'profile'">
            <div class="form">
               <div class="field">
                  <label>First Name<span>*</span></label>
                  <input type="text" placeholder="First Name" [(ngModel)]="newUserFormDataFrom.firstName" >
               </div>
               <div class="field">
                  <label>Last Name<span>*</span></label>
                  <input type="text" placeholder="Last Name" [(ngModel)]="newUserFormDataFrom.lastName" >
               </div>
               <div class="field">
                  <label>Email Address<span>*</span></label>
                  <input type="text" placeholder="Email Address" [(ngModel)]="newUserFormDataFrom.emailAddress" (blur)="validation('email', newUserFormDataFrom.emailAddress)">
               </div>
               <div class="field" *ngIf="!checkLoginType()">
                  <label>Agent ID / ADID</label>
                  <input type="text" placeholder="Only a-z, A-Z, 0-9, @, hyphen(-), and underscore(_) " [(ngModel)]="adid" (blur)="validateADID(adid)">
               </div>
               <div class="field">
                  <label>Phone Number</label>
                  <input type="tel" pattern="[0-9]{10}" maxlength="10" oninput="this.value = this.value.replace(/[^0-9]/g, '')" placeholder="Phone Number" [(ngModel)]="newUserFormDataFrom.phoneNumber" (blur)="validation('phoneNumber', newUserFormDataFrom.phoneNumber)" />
               </div>
               <!-- <div class="field">
                  <label>Login Authentication<span>*</span></label>
                  <app-score-dropdown-menu [config]=passwordType.config [selectedOption]="newUserFormDataFrom.mainAuth" [options]="passwordType.mainPasswordType" (selectedOptionChange)="mainAuthTypeFn($event)"></app-score-dropdown-menu>
               </div>
               <div class="field">
                  <label>Authentication Sub Type<span>*</span></label>
                  <app-score-dropdown-menu [config]=passwordType.config [selectedOption]="newUserFormDataFrom.subAuth" [options]="passwordType.subPasswordType[mainAuthTypeChangeInNewUser]" (selectedOptionChange)="subAuthTypeFn($event)"></app-score-dropdown-menu>
               </div> -->
               <div class="field">
                  <label>Level<span>*</span></label>
                     <app-score-dropdown-menu [config]=passwordType.config [selectedOption]="newUserFormDataFrom.mainAccess" [options]="levelListArray" (selectedOptionChange)="selectLevelNewUser($event)"></app-score-dropdown-menu>
               </div>
               <div class="field">
                  <label>Access Value<span>*</span></label>
                  <!-- Show input field initially -->
                  <input class="inputDisabled" *ngIf="!hasLevelSelected" type="text" placeholder="Only a-z, A-Z, 0-9 and hyphen (-) allowed" [ngModel]="getAccessValueAsString()" (ngModelChange)="onAccessValueInputChange($event)" class="access-value-input" disabled>
                  <!-- Loader appears only if a level is selected and options are loading -->
                  <div *ngIf="hasLevelSelected && isOptionsLoading" class="options-loading-outer">
                    <div class="snake-loader-bar">
                      <div class="snake"></div>
                    </div>
                  </div>
                  <!-- Show dropdown when level is selected and options is not empty and not loading -->
                  <div *ngIf="hasLevelSelected && !isOptionsLoading && options.length > 0" class="chip-dropdown-container" #chipDropdownContainer>
                     <div class="chip-dropdown" [ngClass]="{'active': isDropdownOpen}"  (click)="onChipDropdownClick()">
                        <div class="selected-chips-wrapper">
                           <ng-container *ngIf="selectedItems.length === 0">
                              <span class="placeholder-text">Select options</span>
                           </ng-container>
                           <ng-container *ngIf="selectedItems.length > 0">
                              <div class="chips-container">
                                 <div *ngFor="let item of selectedItems" class="chip" (click)="$event.stopPropagation()">
                                    <span class="chip-text">{{ item }}</span>
                                    <button class="chip-remove" (click)="removeChip(item, $event)">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                       <line x1="18" y1="6" x2="6" y2="18"></line>
                                       <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                    </button>
                                 </div>
                              </div>
                           </ng-container>
                        </div>
                        <span class="dropdown-arrow-chip" [class.open]="isDropdownOpen">
                           <img class="dropdown-icon" [class.open]="isDropdownOpen" src="assets/images/menu-down-dark.svg">
                        </span>
                     </div>
                     <div *ngIf="isDropdownOpen" class="dropdown-menu-chip">
                        <div class="search-wrapper">
                           <!-- <input type="text" placeholder="Search..." [(ngModel)]="searchTerm" (click)="$event.stopPropagation()" class="search-input" /> -->
                           <input type="text" placeholder="Search..." [(ngModel)]="searchTerm" (ngModelChange)="onSearchInput($event)" (click)="$event.stopPropagation()" class="search-input" />
                        </div>
                        <div class="options-list">
                           <div *ngIf="filteredOptionsDropdown.length === 0" class="no-results">
                             No results found.<br>
                             <span *ngIf="levelListArray.length > 2">If you want to add this, click the Add button. To add multiple, separate values with commas.</span><br>
                             <button *ngIf="levelListArray.length > 2" type="button" class="add-btn" (click)="addNewOptionsFromSearch()" [disabled]="!searchTerm.trim()">Add</button>
                           </div>
                           <div *ngFor="let option of filteredOptionsDropdown" class="option-item" (click)="toggleOption(option, $event)">
                              <input type="checkbox" [checked]="isSelected(option)" (change)="toggleOption(option, $event)" (click)="$event.stopPropagation()" class="checkbox" />
                              <span>{{ option }}</span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <!-- Table for cohort acsess -->
               <div class="importUserStep" *ngIf="cohortLevels.length > 1">
                  <table class="cohortTable">
                     <thead>
                        <tr>
                        <th>Cohort Access Level</th>
                        <th>Cohort Access Value</th>
                        <th></th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr *ngFor="let row of cohortAccessList; let i = index">
                           <td>
                              <app-score-dropdown-menu [config]="filteredOptions.dropdownConfig" [selectedOption]="row.selectedLevel" [options]="getAvailableOptions(i)" displayProperty="name" (selectedOptionChange)="onCohortLevelChange($event, i)"></app-score-dropdown-menu>
                           </td>
                           <td>
                              <div class="cohortField">
                                 <input *ngIf="row.selectedLevel && row.selectedLevel !== 'Select a Tag Parameter'" type="text" [(ngModel)]="row.value" placeholder="Cohort value" />
                              </div>
                           </td>
                          <td>
                              <ng-container *ngIf="!row.confirmed && row.selectedLevel && row.selectedLevel !== 'Select a Tag Parameter'; else removeBtn">
                                 <img src="assets/images/checkBox-circle-fill-svg.svg" class="confirm-icon" (click)="confirmRow(i)" alt="Confirm" />
                              </ng-container>
                              <ng-template #removeBtn>
                                 <img class="trash-icon" *ngIf="row.confirmed" src="assets/images/trash-can-outline.svg" alt="Remove" (click)="cohortAccessList.splice(i, 1)" />
                              </ng-template>
                           </td>
                        </tr>
                     </tbody>
                  </table>
                  <button class="cohortAccessAddButton" (click)="addChohortNewAccess()">Add</button>
               </div>
            </div>
         </ng-container>

         <!-- New User Access Form - Access -->
         <ng-container *ngIf="rightPanelHeading === 'New User Access' && currentSubTab === 'access'">
            <div class="form">
               <div class="access-field">
                  <input type="checkbox" class="checkbox" [(ngModel)]="newUserFormDataFrom.is_dashboard_access">
                  <label>Dashboard Access</label>
               </div>
               <div class="access-field">
                  <input type="checkbox" class="checkbox" [(ngModel)]="newUserFormDataFrom.is_report_access">
                  <label>ADR Access</label>
               </div>
               <div class="access-field">
                  <input type="checkbox" class="checkbox" [(ngModel)]="newUserFormDataFrom.is_reply_access">
                  <label>Reply To Customer</label>
               </div>
               <!-- <div class="access-field" *ngIf="positionOfKey === 0">
                  <input type="checkbox" class="checkbox" [(ngModel)]="newUserFormDataFrom.is_setting_access">
                  <label>Settings Access</label>
               </div>
               <div class="access-field" *ngIf="positionOfKey === 0">
                  <input type="checkbox" class="checkbox" [(ngModel)]="newUserFormDataFrom.is_organisation_access">
                  <label>Organization Access</label>
               </div> -->
               <div class="access-field">
                  <input type="checkbox" class="checkbox" [(ngModel)]="newUserFormDataFrom.is_mobile_access">
                  <label>Mobile Access</label>
               </div>
               <ng-container *ngIf="isVisibilityGroup">
                    <div class="access-field">
                        <label>Select Visibility Groups</label>
                    </div>
                    <div class="access-field visibilityGroup" *ngFor="let group of visibilityGroup">
                        <input type="checkbox" class="checkbox" (change)="onAccessGroupChange($event, group.id)" [checked]="newUserFormDataFrom.accessGroup.includes(group.id)">
                        <label class="captialize">{{group.name}}</label>
                    </div>
               </ng-container>
            </div>
         </ng-container>

         <!-- Import Users  -->
         <ng-container *ngIf="rightPanelHeading === 'Import Users'">
            <div class="form rightPanelContent">
               <div class="importUserStep">Step 1 : Download template from <a class="link" href="https://static1.litmusworld.com/litmus/project_mangers_list_sample.xlsx">here</a></div>
               <div class="importUserStep">Step 2 : Fill up the details and save as .csv/.xls/.xlsx file</div>
               <div class="importUserStep">Step 3 : Upload .csv/.xls/.xlsx file to send</div>
            </div>
            <div class="fileUploadContainer">
               <div class="fileUploadBar">
                  <label class="chooseFileBtn">Choose File</label>
                  <div class="fileNameBox">
                     <span>{{ selectedFileName || 'No File Chosen' }}</span>
                  </div>
               </div>
               <div class="uploadBtn" (click)="triggerFileInput()">Upload</div>
               <input type="file" accept=".csv, .xls, .xlsx" #fileInput (change)="onImportFileSelected($event)"class="displayNone" />
            </div>
         </ng-container>

         <!-- Edit User -->
         <ng-container *ngIf="rightPanelHeading === 'Edit user'">
            <div class="form marginTop">
               <div class="field">
                  <label>First Name<span>*</span></label>
                  <input type="text" placeholder="First Name" [(ngModel)]="editUserDetails.firstName" [(ngModel)]="editUserDetails.firstName" (ngModelChange)="checkForModification()" />
               </div>
               <div class="field">
                  <label>Last Name<span>*</span></label>
                  <input type="text" placeholder="Last Name" [(ngModel)]="editUserDetails.lastName" [(ngModel)]="editUserDetails.lastName" (ngModelChange)="checkForModification()" />
               </div>
               <div class="field">
                  <label>Email<span>*</span></label>
                  <input class="inputDisabled" type="email" placeholder="Email" disabled readonly [(ngModel)]="editUserDetails.emailId">
               </div>
               <div class="field">
                  <label>Phone Number</label>
                  <input type="tel" pattern="[0-9]{10}" maxlength="10" oninput="this.value = this.value.replace(/[^0-9]/g, '')" placeholder="Phone Number" [(ngModel)]="editUserDetails.phoneNumber" (ngModelChange)="checkForModification()" />
               </div>
               <!-- <div class="field">
                  <label>Login Authentication<span>*</span></label>
                  <app-score-dropdown-menu [config]="{width: '300px', isDisabled: false, tab: 'scoreViewtype'}" [selectedOption]="editUserDetails.mainAuthType" [options]="passwordType.mainPasswordType" (selectedOptionChange)="onMainAuthTypeChange($event, 'mainAuth'); checkForModification()"></app-score-dropdown-menu>
               </div>
               <div class="field">
                  <label>Authentication Sub Type<span>*</span></label>
                  <app-score-dropdown-menu [config]="{width: '300px', isDisabled: false, tab: 'scoreViewtype'}" [selectedOption]="editUserDetails.subAuthType" [options]="subPasswordTypeOptions || passwordType.subPasswordType[editUserDetails.mainAuthType]" (selectedOptionChange)="onMainAuthTypeChange($event, 'subAuth'); checkForModification()"></app-score-dropdown-menu>
               </div> -->
               <div class="field">
                  <label>Level<span>*</span></label>
                  <input class="inputDisabled" type="text" placeholder="Level" disabled [(ngModel)]="editUserDetails.mainAccess">
               </div>
               <div class="field">
                  <label>Access Value<span>*</span></label>
                  <input *ngIf="options.length === 0 && !isOptionsLoading" type="text" placeholder="Only a-z, A-Z, 0-9 and hyphen (-) allowed" [(ngModel)]="editUserDetails.subAccess" [class.inputDisabled]="editUserDetails.managerType === 3" [disabled]="editUserDetails.managerType === 3" (ngModelChange)="editUserDetails.managerType === 3 ? null : checkForModification()" (focus)="subAcessLevelChange($event, 'focus')"/>
                  <div *ngIf="hasLevelSelected && !isOptionsLoading && options.length > 0" class="chip-dropdown-container" #chipDropdownContainer>
                     <div class="chip-dropdown" [ngClass]="{'active': isDropdownOpen}"  (click)="onChipDropdownClick()">
                        <div class="selected-chips-wrapper">
                           <ng-container *ngIf="selectedItems.length === 0">
                              <span class="placeholder-text">Select options</span>
                           </ng-container>
                           <ng-container *ngIf="selectedItems.length > 0">
                              <div class="chips-container">
                                 <div *ngFor="let item of selectedItems" class="chip" (click)="$event.stopPropagation()">
                                    <span class="chip-text">{{ item }}</span>
                                    <button class="chip-remove" (click)="removeChip(item, $event)">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                       <line x1="18" y1="6" x2="6" y2="18"></line>
                                       <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                    </button>
                                 </div>
                              </div>
                           </ng-container>
                        </div>
                        <span class="dropdown-arrow-chip" [class.open]="isDropdownOpen">
                           <img class="dropdown-icon" [class.open]="isDropdownOpen" src="assets/images/menu-down-dark.svg">
                        </span>
                     </div>
                     <div *ngIf="isDropdownOpen" class="dropdown-menu-chip">
                        <div class="search-wrapper">
                           <!-- <input type="text" placeholder="Search..." [(ngModel)]="searchTerm" (click)="$event.stopPropagation()" class="search-input" /> -->
                           <input type="text" placeholder="Search..." [(ngModel)]="searchTerm" (ngModelChange)="subAcessLevelChange($event, 'change')" (click)="$event.stopPropagation()" class="search-input" />
                        </div>
                        <div class="options-list">
                           <div *ngIf="filteredOptionsDropdown.length === 0" class="no-results">
                              No results found.<br>
                              <span *ngIf="levelListArray.length > 2">If you want to add this, click the Add button. To add multiple, separate values with commas.</span><br>
                              <button *ngIf="levelListArray.length > 2" type="button" class="add-btn" (click)="addNewOptionsFromSearch()" [disabled]="!searchTerm.trim()">Add</button>
                           </div>
                           <div *ngFor="let option of filteredOptionsDropdown" class="option-item" (click)="toggleOption(option, $event)">
                              <input type="checkbox" [checked]="isSelected(option)" (change)="toggleOption(option, $event)" (click)="$event.stopPropagation()" class="checkbox" />
                              <span>{{ option }}</span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div *ngIf="hasLevelSelected && isOptionsLoading" class="options-loading-outer marginLeft">
                     <div class="snake-loader-bar">
                        <div class="snake"></div>
                     </div>
                  </div>
               </div>
            </div>
         </ng-container>

         <!-- Add filters -->
         <ng-container *ngIf="rightPanelHeading === 'Add Filter'">
            <div class="form marginTop">
               <div class="field">
                  <div class="filter-field">
                     <span>Email verification status</span>
                     <span class="phone">Filter users based on their email verification status.</span>
                  </div>
                  <app-score-dropdown-menu *ngIf="dropdownResetKey" [config]="filteredOptions.dropdownConfig" [selectedOption]="emailVerificationSelectedOption" [options]="filteredOptions.emailVerification" (selectedOptionChange)="onFilterChange($event, 'emailVerification')"></app-score-dropdown-menu>
               </div>
               <div class="field">
                  <div class="filter-field">
                     <span>User type</span>
                     <span class="phone">Filter users based on their user type.</span>
                  </div>
                  <app-score-dropdown-menu *ngIf="dropdownResetKey" [config]="filteredOptions.dropdownConfig" [selectedOption]="userTypeSelectedOption" [options]="filteredOptions.userType" (selectedOptionChange)="onFilterChange($event, 'userType')"></app-score-dropdown-menu>
               </div>
               <div class="field">
                  <div class="filter-field">
                     <span>Status</span>
                     <span class="phone">Filter users based on their user status.</span>
                  </div>
                  <app-score-dropdown-menu *ngIf="dropdownResetKey" [config]="filteredOptions.dropdownConfig" [selectedOption]="statusSelectedOption" [options]="filteredOptions.status" (selectedOptionChange)="onFilterChange($event, 'status')"></app-score-dropdown-menu>
               </div>
            </div>
         </ng-container>

         <ng-container *ngIf="rightPanelHeading === 'Upload Hierarchy'">
            <div class="upload-hierarchy-form">
               <div class="upload-hierarchy-header">
                  <span class="lato-bold-dark">Choose a file (xlxs)</span>
                  <span class="lato-regular-light"><img src="assets/images/download.svg">Hierarchy file</span>
               </div>
            </div>
            <div class="fileUploadContainer">
               <div class="fileUploadBar">
                  <label class="chooseFileBtn">Choose File</label>
                  <div class="fileNameBox">
                     <span>{{ selectedFileName || 'No File Chosen' }}</span>
                  </div>
               </div>
               <div class="uploadBtn" (click)="triggerFileInput()">Upload</div>
               <input type="file" accept=".csv, .xls, .xlsx" #fileInput (change)="onImportFileSelected($event)" class="displayNone" />
            </div>
            <div class="toggle-container">
               <div class="toggle-box">
                  <button class="toggle-option active">Existing File Mapping</button>
                  <button class="toggle-option">New File Mapping</button>
               </div>
            </div>
         </ng-container>
      </div>
      <!-- Panel Footer Container -->

      <!-- Footer for Edit User -->
      <ng-container *ngIf="rightPanelHeading === 'Edit user'">
         <div class="panel-footer-container">
            <button class="clear-btn" (click)="closeRightPanelFN(rightPanelHeading)">Cancel</button>
            <button class="button primary-btn save-btn" [ngClass]="{ 'disabledSubmitButton': !isEditModification }" (click)="upadteUserDetails(editUserDetails)">Save</button>
         </div>
      </ng-container>

      <!-- Footer for Add Filter -->
      <ng-container *ngIf="rightPanelHeading === 'Add Filter'">
         <div class="panel-footer-container">
            <button class="clear-btn clearAll-btn" (click)="clearAllFilter()">Clear all</button>
            <button class="clear-btn" (click)="closeRightPanelFN('Add Filter')">Cancel</button>
            <button class="button primary-btn save-btn" [ngClass]="{ 'disabledSubmitButton': !isApplyEnabled }" (click)="applyFilter()">Apply</button>
         </div>
      </ng-container>

      <!-- Footer for Import Users -->
      <ng-container *ngIf="rightPanelHeading === 'Import Users'">
         <div class="panel-footer-container">
            <button class="clear-btn" (click)="closeRightPanelFN(rightPanelHeading)">Cancel</button>
            <button class="button primary-btn save-btn" [ngClass]="{ 'disabledSubmitButton': !isFileReady }" (click)="onImportButton()">Import</button>
         </div>
      </ng-container>

      <!-- Footer for New User Access -->
      <ng-container *ngIf="rightPanelHeading === 'New User Access'">
         <div class="panel-footer-container">
            <button class="clear-btn" (click)="closeRightPanelFN(rightPanelHeading)">Cancel</button>
            <button class="button primary-btn save-btn" [ngClass]="{ 'disabledSubmitButton': currentSubTab === 'profile' && !isProfileFormValid() }" [disabled]="currentSubTab === 'profile' && !isProfileFormValid()" (click)="onNextButtonClick()">Next</button>
         </div>
      </ng-container>
   </div>
</div>